import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ScToasterPlugin from '@trendyol/sc-ui-kit/ScToaster.plugin';
import ScLoadingOverlay from '@trendyol/sc-ui-kit/ScLoadingOverlay.plugin';
import ScToaster from '@trendyol/sc-ui-kit/ScToaster';
import InputMaskDirective from './directives/InputMaskDirective';
import VeeValidate, { Validator } from 'vee-validate';
import ValidatorTr from 'vee-validate/dist/locale/tr';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import CustomValidator from './plugins/customValidator';
import App from './App.vue';
import router from './router';
import messages from './i18n/index';
import Gtm from '@/plugins/Gtm';
import 'swiper/css/swiper.css';

const isProduction = process.env.VUE_APP_MODE === 'production';

if (isProduction) {
  import('@trendyol/sc-utils/').then(({ SentryService }) => {
    const sentryService = new SentryService({
      dsn: process.env.VUE_APP_SENTRY_IO_DSN,
      release: process.env.VUE_APP_RELEASE_VERSION || 'N/A',
      environment: 'production',
    });

    sentryService.init(Vue);
  });
}

const VeeValidateConfig = {
  fieldsBagName: 'validationFields',
  fastExit: false,
  events: 'input',
};

Vue.use(VeeValidate, VeeValidateConfig);
Validator.localize('tr', ValidatorTr);
Vue.use(CustomValidator, Validator);
Vue.use(Gtm);
Vue.use(VueAwesomeSwiper);

Vue.directive('mask', InputMaskDirective);

Vue.use(VueI18n);
Vue.use(ScToasterPlugin, { ScToaster });
Vue.use(ScLoadingOverlay);

const locale = 'tr';
const i18n = new VueI18n({
  locale,
  messages,
});

Vue.config.productionTip = false;

window.currentApp = new Vue({
  router,
  i18n,
  render: h => h(App),
  data () {
    return {
      publicPath: process.env.BASE_URL,
      solutionPartner: process.env.VUE_APP_SOLUTION_PARTNERS,
    };
  },
}).$mount('#app');
